import React from 'react';

const PhotoHistoryIcon = ({ ...rest }) => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_5301_1557)">
        <g opacity="0.2">
          <path d="M22.6461 20.2771C22.7398 20.1795 22.867 20.1246 22.9996 20.1246C23.1322 20.1246 23.2594 20.1795 23.3532 20.2771C23.4469 20.3748 23.4996 20.5073 23.4996 20.6454V23.034L24.8531 24.4439C24.9442 24.5421 24.9946 24.6737 24.9934 24.8102C24.9923 24.9468 24.9397 25.0774 24.847 25.174C24.7543 25.2705 24.6289 25.3253 24.4978 25.3265C24.3667 25.3277 24.2404 25.2752 24.1461 25.1803L22.6461 23.6178C22.5523 23.5202 22.4996 23.3877 22.4996 23.2496V20.6454C22.4996 20.5073 22.5523 20.3748 22.6461 20.2771Z" fill="currentColor"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M11.7044 31.265C12.1748 31.755 12.74 32 13.4 32H32.6C33.2592 32.0008 33.824 31.7562 34.2944 31.2662C34.7648 30.7762 35 30.1875 35 29.5V17C35.0008 16.3133 34.766 15.725 34.2956 15.235C33.8252 14.745 33.26 14.5 32.6 14.5H23L20.6 12H13.4C12.7408 11.9992 12.176 12.2438 11.7056 12.7338C11.2352 13.2238 11 13.8125 11 14.5V29.5C10.9992 30.1867 11.234 30.775 11.7044 31.265ZM27.9996 23.2496C27.9996 20.373 25.7611 18.0413 22.9996 18.0413C20.2381 18.0413 17.9996 20.373 17.9996 23.2496C17.9996 26.1262 20.2381 28.4579 22.9996 28.4579C25.7611 28.4579 27.9996 26.1262 27.9996 23.2496Z" fill="currentColor"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5301_1557">
          <rect width="44" height="44" rx="12" fill="currentColor"/>
        </clipPath>
      </defs>
    </svg>

  );
};

export default PhotoHistoryIcon;